import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    FiGrid,
    FiUserCheck,
    FiUsers,
    FiCalendar,
    FiHelpCircle,
    FiDollarSign,
    FiEdit3,
} from 'react-icons/fi';
import '../../../../assets/css/admin/sidebar.css';

const Sidebar = ({ isOpen, onNavigate }) => {
    const location = useLocation();

    const menuItems = [
        { id: 'dashboard', title: 'Dashboard', icon: <FiGrid />, path: '/admin/dashboard' },
        { id: 'therapists', title: 'Therapist Management', icon: <FiUserCheck />, path: '/admin/therapists' },
        { id: 'patients', title: 'Patient Management', icon: <FiUsers />, path: '/admin/patients' },
        { id: 'appointments', title: 'Appointments Overview', icon: <FiCalendar />, path: '/admin/appointments' },
        // { id: 'disputes', title: 'Disputes', icon: <FiAlertCircle />, path: '/admin/disputes' },
        { id: 'tickets', title: 'Support Tickets', icon: <FiHelpCircle />, path: '/admin/tickets' },
        { id: 'earningscomissions', title: 'Earnings & Commissions', icon: <FiDollarSign />, path: '/admin/earnings' },
        { id: 'blog', title: 'Blog Management', icon: <FiEdit3 />, path: '/admin/blog' },


        // { id: 'analytics', title: 'Analytics Dashboard', icon: '📈', path: '/admin/analytics' },
        // { id: 'logs', title: 'System Logs & Reports', icon: '📋', path: '/admin/logs' },
        // { id: 'settings', title: 'Settings', icon: '⚙️', path: '/admin/settings' },
        // { id: 'notifications', title: 'Notifications', icon: '🔔', path: '/admin/notifications' }
    ];

    const isActive = path => location.pathname === path;

    return (
        <aside className={`admin-sidebar ${isOpen ? 'open' : 'closed'}`}>
            <div className="admin-sidebar-header">
                <div className="admin-logo-container">
                    <svg width="40" height="40" viewBox="0 0 100 100" className="admin-logo-svg">
                        <circle cx="50" cy="50" r="48" fill="#00005a" />
                        <circle cx="50" cy="48" r="32" fill="#FF6F00" />
                        <circle cx="50" cy="48" r="22" fill="#FFFFFF" />
                        <path d="M 38 70 L 30 82 L 48 74 Z" fill="#FF6F00" />
                    </svg>
                    {isOpen && (
                        <span className="admin-logo-text">
                            Smart<span className="admin-logo-highlight">Therapy</span>
                        </span>
                    )}
                </div>
            </div>

            <nav className="admin-sidebar-nav">
                {menuItems.map(item => (
                    <div key={item.id} className="admin-nav-item-wrapper">
                        <Link
                            to={item.path}
                            onClick={onNavigate}
                            className={`admin-nav-item ${isActive(item.path) ? 'active' : ''}`}
                        >
                            <span className="admin-nav-icon">{item.icon}</span>
                            {isOpen && <span className="admin-nav-text">{item.title}</span>}
                        </Link>
                    </div>
                ))}
            </nav>
        </aside>
    );
};

export default Sidebar;